import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import C from '../../constants/routes';
import IndexStyle from './style.scss';
import styled from 'styled-components';
import Cx from 'classnames';

const StyledFormControl = styled(FormControl)`
    && {
        color:${props => props.theme.textColor};
    }
 `;

class searchInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.initSearch = this.initSearch.bind(this);
        this.checkEnter = this.checkEnter.bind(this);
    }

    checkEnter(event){
        if ( event.keyCode == 13) {
            this.initSearch();
        }
    }

    initSearch(){
        let inputElement = ReactDOM.findDOMNode(this.searchTextInput);
        if ( inputElement.value.trim().length > 0 ) {
            let keyword = ReactDOM.findDOMNode(this.searchTextInput).value;
            this.props.actions.setSearch(keyword);
            this.props.actions.getSearchData(keyword);
            this.props.history.push(C.SEARCH_RESULT);
            inputElement.focus();
        } else {
            inputElement.value = '';
            inputElement.focus();
        }
    }

    render() {
        let inputPlaceholder = this.props.intlObject['ssp.search.input.placeholder'];
        let buttonArialabel = this.props.intlObject['ssp.search.button.arialabel'];
        let inputDefaultValue = this.props.location.pathname.indexOf(C.SEARCH_RESULT) > -1 ? this.props.searchKeyword : '';
        return(
            <div role="form">
                <InputGroup>
                    <StyledFormControl  role="search" aria-label={inputPlaceholder} componentClass="input" type='text' placeholder={inputPlaceholder} ref={(input) => { this.searchTextInput = input; }} onKeyUp={this.checkEnter} defaultValue={inputDefaultValue} />
                    <InputGroup.Button>
                        <Button aria-label={buttonArialabel}  onClick={this.initSearch} className={IndexStyle.searchBtn}><span className={Cx('iconIssue', 'searchIcon', IndexStyle.searchIcon)}></span></Button>
                    </InputGroup.Button>
                </InputGroup>
            </div>
        )
    }
}

searchInput.propTypes = {
    intlObject :PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    searchKeyword :PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
};

export default withRouter(searchInput);



// WEBPACK FOOTER //
// ./components/Toolbar/search.js